import {json} from "p3";
import definitions from "../../definitions";
import MinigameChickenRun from "./minigames/MinigameChickenRun";
import MinigameDucklingTrain from "./minigames/MinigameDucklingTrain";
import MinigameSnakeAttack from "./minigames/MinigameSnakeAttack";
import MinigameSwanlingTrain from "./minigames/MinigameSwanlingTrain";
import MinigameSimonSays from "./minigames/MinigameSimonSays";
import QuestDummy from "./QuestDummy";
import QuestFetch from "./QuestFetch";
import QuestFillCollectionJar from "./QuestFillCollectionJar";
import QuestKill from "./QuestKill";
import QuestBossFight from "./QuestBossFight";
import MinigameButterflyCatch from "./minigames/MinigameButterflyCatch";
import QuestDefeatBoss from "./QuestDefeatBoss";
import MinigameCrabCatch from "./minigames/MinigameCrabCatch";
import settings from "../../settings";
import { locale } from "../../utils";

export default class QuestFactory {
    /**
     * @param {string} type
     * @param {string} id
     * @param {string} owner
     * @returns {Quest}
     */
    static create(type, id, owner) {
        switch (type) {
            case definitions.QUEST_TYPE.BOSS_FIGHT: {
                return new QuestBossFight(id, owner);
            }
            case definitions.QUEST_TYPE.DUMMY: {
                return new QuestDummy(id, owner);
            }
            case definitions.QUEST_TYPE.DEFEAT_BOSS: {
                return new QuestDefeatBoss(id, owner);
            }
            case definitions.QUEST_TYPE.FETCH: {
                return new QuestFetch(id, owner);
            }
            case definitions.QUEST_TYPE.FILL_COLLECTION_JAR: {
                return new QuestFillCollectionJar(id, owner);
            }
            case definitions.QUEST_TYPE.KILL: {
                return new QuestKill(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_BUTTERFLY_CATCH: {
                return new MinigameButterflyCatch(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_CHICKEN_RUN: {
                return new MinigameChickenRun(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_CRAB_CATCH: {
                return new MinigameCrabCatch(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_DUCKLING_TRAIN: {
                return new MinigameDucklingTrain(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_SIMON_SAYS: {
                return new MinigameSimonSays(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_SNAKE_ATTACK: {
                return new MinigameSnakeAttack(id, owner);
            }
            case definitions.QUEST_TYPE.MINIGAME_SWANLING_TRAIN: {
                return new MinigameSwanlingTrain(id, owner);
            }
        }
        return null;
    }

    /**
     * @param {string} type
     * @return {boolean}
     */
    static isMinigame(type) {
        switch (type) {
            case definitions.QUEST_TYPE.MINIGAME_BUTTERFLY_CATCH:
            case definitions.QUEST_TYPE.MINIGAME_CHICKEN_RUN:
            case definitions.QUEST_TYPE.MINIGAME_CRAB_CATCH:
            case definitions.QUEST_TYPE.MINIGAME_DUCKLING_TRAIN:
            case definitions.QUEST_TYPE.MINIGAME_SNAKE_ATTACK:
            case definitions.QUEST_TYPE.MINIGAME_SWANLING_TRAIN:
            case definitions.QUEST_TYPE.MINIGAME_SIMON_SAYS: {
                return true;
            }
        }
        return false;
    }

    /**
     * @param {string} type
     * @returns {boolean}
     */
    static isBossFight(type) {
        switch (type) {
            case definitions.QUEST_TYPE.BOSS_FIGHT: {
                return true;
            }
        }
        return false;
    }

    static getCompletedQuests(quests) {
        let total = 0;
        QuestFactory.checkQuests((npc, questId, quest) => {
            if (quests[npc + "|" + questId] === true) {
                total++;
            }
        });
        return total;
    }

    static getTotalNumberOfQuests() {
        let total = 0;
        let str = "";
        QuestFactory.checkQuests((npc, questId, quest) => {
            total++;
            //str += locale(json(npc).character.name) + ' - ' + locale(quest.name) + ': ' + locale(quest.description) + '\n';
        });
        console.log('total:' + total);
        //console.log(str);
        return total;
    }

    static checkQuests(iterate) {
        let total = 0;
        for (let i in definitions.NPC_ID) {
            let data;
            try {
                data = json(definitions.NPC_ID[i]);
            } catch(err) {
                continue;
            }
            if (data && data.character && data.character.quests && data.quests) {

                if (data.character.location) {
                    try {
                        if(json(data.character.location).metadata.phase > settings.PHASE) {
                            continue;
                        }
                    } catch(e) {

                    }
                }

                for (let j in data.quests) {
                    let quest = data.quests[j];
                    if (quest &&
                        (data.character.quests.indexOf(j) > -1 || definitions.BONUS_QUESTS.indexOf(definitions.NPC_ID[i] + '|' + j) > -1) &&
                        !(quest.phase > settings.PHASE) &&
                        !this.isMinigame(quest.type) &&
                        !this.isBossFight(quest.type)) {
                            iterate(definitions.NPC_ID[i], j, quest);
                    }
                }
            }
        }
        return total;
    }
}